import React from 'react'
import { NavLink } from 'react-router-dom'
import type { NavItem } from './types'

export type NavVariant = 'rail' | 'drawer' | 'sheet' | 'dock'

export interface NavGroup { name?: string; items: NavItem[] }

/** Gruppiert Einträge nach item.group in Reihenfolge des ersten Vorkommens. */
export function groupItems(items: NavItem[]): NavGroup[] {
  const groups: NavGroup[] = []
  for (const it of items) {
    let g = groups.find(x => x.name === it.group)
    if (!g) { g = { name: it.group, items: [] }; groups.push(g) }
    g.items.push(it)
  }
  return groups
}

interface NavEntryProps {
  item: NavItem
  variant: NavVariant
  /** Zeigt den Einsatz-Live-Hinweis für requiresMission-Einträge ohne explizites live-Feld. */
  hasMission?: boolean
  onNavigate?: () => void
  /** Kurzbezeichnung (Dock). */
  shortLabel?: string
}

/** Ein Navigationseintrag (NavLink) für Rail, Drawer, Bottom-Sheet und Dock. */
export function NavEntry({ item, variant, hasMission, onNavigate, shortLabel }: NavEntryProps) {
  const live = item.live !== undefined ? item.live : !!(item.requiresMission && hasMission)
  const showLive = item.live !== undefined ? item.live : false
  const dot = variant === 'rail' || variant === 'dock' ? (showLive || item.badge) : false
  return (
    <NavLink
      to={item.path}
      onClick={onNavigate}
      className={`ui-it ui-it--${variant}`}
      aria-label={variant === 'rail' ? item.label : undefined}
      title={variant === 'rail' ? item.label : undefined}
      data-live={live ? 'true' : undefined}
    >
      <span className="ui-it-ic" aria-hidden="true">
        {item.icon}
        {dot && <i className={showLive ? 'ui-dot ui-dot--live' : 'ui-dot'} />}
      </span>
      <span className="ui-lb">{variant === 'dock' ? (shortLabel ?? item.label) : item.label}</span>
      {variant !== 'dock' && variant !== 'rail' && (
        <>
          {item.badge && <span className={`ui-tag ui-tag--${item.badgeVariant ?? 'info'}`}>{item.badge}</span>}
          {showLive && <span className="ui-tag ui-tag--success">Live</span>}
          {!showLive && item.live === undefined && item.requiresMission && hasMission && <span className="ui-tag ui-tag--info">Live</span>}
        </>
      )}
    </NavLink>
  )
}
